import { render, staticRenderFns } from "./RewardDetailPanelNewLayout.vue?vue&type=template&id=5b179e06&scoped=true"
import script from "./RewardDetailPanelNewLayout.vue?vue&type=script&lang=js"
export * from "./RewardDetailPanelNewLayout.vue?vue&type=script&lang=js"
import style0 from "./RewardDetailPanelNewLayout.vue?vue&type=style&index=0&id=5b179e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b179e06",
  null
  
)

export default component.exports